// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import SystemProperties from './system_properties';

export {searchableStrings} from './system_properties';

export default SystemProperties;
